import React from "react";
import "./TitleHeader.css";

const TitleHeader = ({ title, subtitle, onPress, _id }) => {

  return (
    <div className="titleHeader">
      <div className="titleHeader__content">
        <div className="titleHeader__titleContainer">
          <div className="titleHeader__line titleHeader__line--left"></div>
          <h2 className="titleHeader__title" title={title}>
            {(title || "").toUpperCase()}
          </h2>
          <div className="titleHeader__line titleHeader__line--right"></div>
        </div>
        {subtitle && (
          <p className="titleHeader__subtitle" title={subtitle}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
};

export default TitleHeader; 